import { fetchBeautyFashion } from "@/lib/lamka";

const KEY = "lamka_browse";

// Remembers the order shoppers were browsing so a product page can swipe to the next/previous piece.
export const rememberBrowse = (items) => {
  if (items?.length) sessionStorage.setItem(KEY, JSON.stringify(items.map((i) => ({ id: i.id, img: i.images?.[0] || null }))));
};

export const getBrowse = async () => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (saved?.length) return saved;
  } catch {}
  const list = await fetchBeautyFashion();
  rememberBrowse(list);
  return list.map((i) => ({ id: i.id, img: i.images?.[0] || null }));
};
